import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Region } from 'src/app/shared/models/region';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { RegionModalAjoutComponent } from '../modal/region-modal-ajout/region-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { RegionModalDetailComponent } from '../modal/region-modal-detail/region-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-region',
	templateUrl: './list-region.component.html',
	styleUrls: ['./list-region.component.scss']
})
export class ListRegionComponent implements OnInit {
	region: Region[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	regionCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editRegionModalRef: BsModalRef;
	addRegionModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getRegion();
		this.isAddable = true;
	}

	getRegion(): void {
		this.isListingLoading = true;
		this.facade.regionService.getAllRegion().subscribe({
			next: (val) => {
				this.region = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.region.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.region = [];
			}
		});
	}

	selectRegion(region: Region): void {
		const link = ['/region', region.id];
		this.router.navigate(link);
	}

	importRegion(event: any): void {
		this.regionCsvFile = event.target.files[0];

		this.facade.regionService
			.importRegion(this.regionCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} region ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getRegion();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addRegionModalRef = this.modalService.show(
			RegionModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addRegionModalRef.onHide.subscribe((reason: string | any) => {
			this.getRegion();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(region: Region) {
		const initialState = {
			region: region
		};
		this.editRegionModalRef = this.modalService.show(
			RegionModalDetailComponent,
			{
				class: 'modal-lg',
				initialState
			}
		);

		this.editRegionModalRef.onHide.subscribe((reason: string | any) => {
			this.getRegion();
		});
	}
}
